export const config = {
    // localApiUrl: "http://localhost:3001"
    localApiUrl: "https://backend.heyivy.co.uk"
}

